import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  rating: number;
  views: string;
  quality: string;
  duration?: string;
  updateInfo?: string;
}

export default function VideoCard({
  id,
  title,
  category,
  categorySlug,
  thumbnail,
  rating,
  views,
  quality,
  duration,
  updateInfo,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-video mb-3">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          title={`${title} - 小蓝视频高清在线观看`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-white">
            {quality}
          </span>
        </div>

        <div className="absolute top-2 right-2">
          <span className="flex items-center gap-1 px-2 py-0.5 rounded text-xs bg-black/60 text-white">
            <i className="ri-star-fill text-accent-500 text-[10px]"></i>
            {rating}
          </span>
        </div>

        {duration && (
          <div className="absolute bottom-2 right-2">
            <span className="px-2 py-0.5 rounded text-xs bg-black/60 text-white">
              {duration}
            </span>
          </div>
        )}

        {updateInfo && (
          <div className="absolute bottom-2 right-2">
            <span className="px-2 py-0.5 rounded text-xs bg-primary-500/90 text-white">
              {updateInfo}
            </span>
          </div>
        )}

        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-white/25 backdrop-blur-sm flex items-center justify-center">
            <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>

      <div className="flex items-center gap-2 mt-1.5">
        <Link
          to={`/category/${categorySlug}`}
          onClick={(e) => e.stopPropagation()}
          className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          {category}
        </Link>
        <span className="text-xs text-foreground-400">{views}次观看</span>
      </div>
    </Link>
  );
}